// extracted by mini-css-extract-plugin
export default {"base":"Button_base__rCuO6"};